module.exports = __webpack_public_path__ + "static/media/qrcode.12f7b53c.png";